import { Component, OnInit } from '@angular/core';


@Component({
    selector: 'itpx-products-dashboard',
    templateUrl: './product-data-dashboard.component.html'
})
export class ProductDataDashboardComponent {

    constructor() {}

    private tiles: Array<any> = [
        {
            title: 'Catalogs',
            redirectPath: 'catalogs',
            description: 'Manage & Create Catalogs',
            icon: 'fa-archive'
        }, {
            title: 'Categories',
            redirectPath: 'categories',
            description: 'Manage & Create Categories',
            icon: 'fa-folder'
        },  {
            title: 'Sub-Categories',
            redirectPath: 'product-groups',
            description: 'Manage (Seller) Sub-categories',
            icon: 'fa-folder-open'
        }, {
            title: 'Products',
            redirectPath: 'products',
            description: 'Manage (Master) Products',
            icon: 'fa-book'
        }, {
            title: 'Product Variants',
            redirectPath: 'product-variants',
            description: 'Manage Product Variants',
            icon: 'fa-list-alt'
        }, {
            title: 'Product Segments',
            redirectPath: 'product-segments',
            description: 'Manage Restricted Product Segments',
            icon: 'fa-lock-alt'
        }, {
            title: 'Topics',
            redirectPath: 'topics-subtopics',
            description: 'Manage Topic & Sub-topic Library',
            icon: 'fa-flag'
        }, {
            title: 'Custom Topics',
            redirectPath: 'custom-topics-subtopics',
            description: 'Manage Custom Topic & Sub-topic Library',
            icon: 'fas fa-drafting-compass'
        }, {
            title: 'Brands',
            redirectPath: 'brands',
            description: 'Manage Brand Library',
            icon: 'fa-registered'
        },
        {
            title: 'Surcharges',
            redirectPath: 'surcharges',
            description: 'Manage & Create Surcharges',
            icon: 'fa-cubes'
        }
    ];
}



// WEBPACK FOOTER //
// ./src/app/agora/components/product-data/dashboard/product-data-dashboard.component.ts